/* eslint-disable */

//tslint:disable

import { IModel, IModelResponse } from '@cian/http-api/shared/model';

export type TWebDeleteFavoritesModel = IModel<IWebDeleteFavoritesRequest, TWebDeleteFavoritesResponse>;

export interface IWebDeleteFavoritesRequest {
  /** Тип сделки **/
  dealType?: EDealType | null;
  /** Тип сущности **/
  entityType?: EEntityType | null;
}

export type TWebDeleteFavoritesResponse = IWebDeleteFavoritesResponse200 | IWebDeleteFavoritesResponse400;

export interface IWebDeleteFavoritesResponse200 extends IModelResponse<IWebDeleteFavoritesResponse> {
  statusCode: 200;
}

export interface IWebDeleteFavoritesResponse400 extends IModelResponse<IWebDeleteFavoritesResponseError> {
  statusCode: 400;
}

export interface IWebDeleteFavoritesResponse {}

export interface IWebDeleteFavoritesResponseError {
  errors: any[];
  message: string;
}

export type TResponses = IWebDeleteFavoritesResponse | IWebDeleteFavoritesResponseError;

export enum EDealType {
  /** Аренда **/
  Rent = 'rent',
  /** Продажа **/
  Sale = 'sale',
}

export enum EEntityType {
  /** Коммерческая **/
  Commercial = 'commercial',
  /** ЖК **/
  Newbuilding = 'newbuilding',
  /** Жилая **/
  Residential = 'residential',
  /** Загородка **/
  Suburban = 'suburban',
}

export interface IMappers<TResponse200, TResponse400> {
  200(response: IWebDeleteFavoritesResponse): TResponse200;
  400(response: IWebDeleteFavoritesResponseError): TResponse400;
}
